export const EventLogs = {
    // HL7 EVENTS
    HL7_MESSAGE_RECEIVED: 'HL7_MESSAGE_RECEIVED',
    HL7_MESSAGE_PROCESSED: 'HL7_MESSAGE_PROCESSED',
    HL7_MESSAGE_FAILED: 'HL7_MESSAGE_FAILED',
    HL7_MESSAGE_SENT: 'HL7_MESSAGE_SENT',
    HL7_MESSAGE_SEND_FAILED: 'HL7_MESSAGE_SEND_FAILED',
    HL7_PRODUCTION_REPORT_INCOMPLETE: 'HL7_PRODUCTION_REPORT_INCOMPLETE',
    // PATIENT EVENTS
    PATIENT_CREATED: 'PATIENT_CREATED',
    PATIENT_UPDATED: 'PATIENT_UPDATED',
    PATIENT_ACCESSED: 'PATIENT_ACCESSED',
    PATIENT_DEACTIVATED: 'PATIENT_DEACTIVATED',
    PATIENT_IMPORTED: 'PATIENT_IMPORTED',
    PATIENT_MERGED: 'PATIENT_MERGED',
    PATIENT_CHARACTERISTICS_UPDATED: 'PATIENT_CHARACTERISTICS_UPDATED',
    PATIENT_GFR_ADDED: 'PATIENT_GFR_ADDED',
    PATIENT_GFR_DELETED: 'PATIENT_GFR_DELETED',
    PATIENT_DOSES_RECALCULATED: 'PATIENT_DOSES_RECALCULATED',
    PATIENT_UPDATED_BY_INTERFACE: 'PATIENT_UPDATED_BY_INTERFACE',
    // AUTH EVENTS
    IMPERSONATION_ENDED: 'IMPERSONATION_ENDED',
    USER_TEMPORARY_PASSWORD_SET: 'USER_TEMPORARY_PASSWORD_SET',
    // SETTINGS
    SETTINGS_UPDATED: 'SETTINGS_UPDATED',
    //USER EVENTS
    USER_CREATED: 'USER_CREATED',
    USER_UPDATED: 'USER_UPDATED',
    USER_DEACTIVATED: 'USER_DEACTIVATED',
    USER_REACTIVATED: 'USER_REACTIVATED',
    USER_GROUP_REMOVED: 'USER_GROUP_REMOVED',
    USER_GROUP_ADDED: 'USER_GROUP_ADDED',
    USER_DELETED: 'USER_DELETED',
    //GROUPS EVENTS
    GROUP_CREATED: 'GROUP_CREATED',
    GROUP_UPDATED: 'GROUP_UPDATED',
    GROUP_DELETED: 'GROUP_DELETED',
    GROUP_UPDATED_STATUS: 'GROUP_UPDATED_STATUS',
    //SUBSTANCE CATEGORY EVENTS
    CATEGORY_CREATED: 'CATEGORY_CREATED',
    CATEGORY_UPDATED: 'CATEGORY_UPDATED',
    CATEGORY_DEACTIVATED: 'CATEGORY_DEACTIVATED',
    CATEGORY_REACTIVATED: 'CATEGORY_REACTIVATED',
    CATEGORY_DELETED: 'CATEGORY_DELETED',
    //SUBSTANCE SUBCATEGORY EVENTS
    SUBCATEGORY_CREATED: 'SUBCATEGORY_CREATED',
    SUBCATEGORY_UPDATED: 'SUBCATEGORY_UPDATED',
    SUBCATEGORY_DELETED: 'SUBCATEGORY_DELETED',
    // PROTOCOLS
    PROTOCOL_CREATED: 'PROTOCOL_CREATED',
    PROTOCOL_UPDATED: 'PROTOCOL_UPDATED',
    PROTOCOL_DELETED: 'PROTOCOL_DELETED',
    PROTOCOL_DEACTIVATED: 'PROTOCOL_DEACTIVATED',
    PROTOCOL_ACTIVATED: 'PROTOCOL_ACTIVATED',
    PROTOCOL_THERAPY_SEQUENCE_SUBSTANCE_CHANGED: 'PROTOCOL_THERAPY_SEQUENCE_SUBSTANCE_CHANGED',
    PROTOCOL_THERAPY_SEQUENCE_DOSE_CHANGED: 'PROTOCOL_THERAPY_SEQUENCE_DOSE_CHANGED',
    PROTOCOL_THERAPY_SEQUENCE_ADDED: 'PROTOCOL_THERAPY_SEQUENCE_ADDED',
    PROTOCOL_THERAPY_SEQUENCE_DELETED: 'PROTOCOL_THERAPY_SEQUENCE_DELETED',
    PROTOCOL_THERAPY_SEQUENCE_MEDICINE_ADDED: 'PROTOCOL_THERAPY_SEQUENCE_MEDICINE_ADDED',
    PROTOCOL_THERAPY_SEQUENCE_MEDICINE_REMOVED: 'PROTOCOL_THERAPY_SEQUENCE_MEDICINE_REMOVED',
    PROTOCOL_THERAPY_SEQUENCE_UPDATED: 'PROTOCOL_THERAPY_SEQUENCE_UPDATED',
    PATIENT_THERAPY_SEQUENCE_ADDED: 'PATIENT_THERAPY_SEQUENCE_ADDED',
    PATIENT_THERAPY_SEQUENCE_UPDATED: 'PATIENT_THERAPY_SEQUENCE_UPDATED',
    PATIENT_THERAPY_SEQUENCE_DELETED: 'PATIENT_THERAPY_SEQUENCE_DELETED',
    PATIENT_THERAPY_SEQUENCE_MEDICINE_ADDED: 'PATIENT_THERAPY_SEQUENCE_MEDICINE_ADDED',
    PATIENT_THERAPY_SEQUENCE_MEDICINE_UPDATED: 'PATIENT_THERAPY_SEQUENCE_MEDICINE_UPDATED',
    PATIENT_THERAPY_SEQUENCE_MEDICINE_DELETED: 'PATIENT_THERAPY_SEQUENCE_MEDICINE_DELETED',
    PATIENT_THERAPY_SEQUENCE_PROTOCOL_ADDED: 'PATIENT_THERAPY_SEQUENCE_PROTOCOL_ADDED',
    PATIENT_THERAPY_SEQUENCE_PROTOCOL_UPDATED: 'PATIENT_THERAPY_SEQUENCE_PROTOCOL_UPDATED',
    PATIENT_THERAPY_SEQUENCE_PROTOCOL_DELETED: 'PATIENT_THERAPY_SEQUENCE_PROTOCOL_DELETED',
    PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_ADDED: 'PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_ADDED',
    PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_UPDATED: 'PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_UPDATED',
    PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_DELETED: 'PATIENT_THERAPY_SEQUENCE_MEDICINE_PROTOCOL_DELETED',
    PATIENT_PROTOCOL_CYCLES_UPDATED: 'PATIENT_PROTOCOL_CYCLES_UPDATED',
    PATIENT_TREATMENT_STOPPED: 'PATIENT_TREATMENT_STOPPED',
    PATIENT_PROTOCOL_STOPPED: 'PATIENT_PROTOCOL_STOPPED',
    PATIENT_PROTOCOL_REACTIVATED: 'PATIENT_PROTOCOL_REACTIVATED',
    PATIENT_INSTRUCTION_NOTE_ADDED: 'PATIENT_INSTRUCTION_NOTE_ADDED',
    PATIENT_INSTRUCTION_NOTE_PROTOCOL_ADDED: 'PATIENT_INSTRUCTION_NOTE_PROTOCOL_ADDED',
    PATIENT_INSTRUCTION_NOTE_UPDATED: 'PATIENT_INSTRUCTION_NOTE_UPDATED',
    PATIENT_INSTRUCTION_NOTE_PROTOCOL_UPDATED: 'PATIENT_INSTRUCTION_NOTE_PROTOCOL_UPDATED',
    PRESCRIPTION_STATUS_CHANGE: 'PRESCRIPTION_STATUS_CHANGE',
    PRESCRIPTION_VALIDATION_REMOVED: 'PRESCRIPTION_VALIDATION_REMOVED',
    PRESCRIPTIONS_PRINTED: 'PRESCRIPTIONS_PRINTED',
    PRESCRIPTION_DOSE_LIMIT_CONFIRMED: 'PRESCRIPTION_DOSE_LIMIT_CONFIRMED',
    // CUSTOMERS
    CUSTOMERS_DEACTIVATED: 'CUSTOMERS_DEACTIVATED',
    CUSTOMERS_DELETED: 'CUSTOMERS_DELETED',
    // ORDERS / PRODUCTION
    ORDER_PRODUCTION_STARTED: 'ORDER_PRODUCTION_STARTED',
    BATCH_CONSUMED: 'BATCH_CONSUMED',
    PRODUCTION_COMPLETED: 'PRODUCTION_COMPLETED',
    PRODUCTION_RELEASED: 'PRODUCTION_RELEASED',
    PRODUCTION_STEP_COMPLETED: 'PRODUCTION_STEP_COMPLETED',
    PRODUCTION_STEP_REWEIGHED: 'PRODUCTION_STEP_REWEIGHED',
    PRODUCTION_STEP_REDONE: 'PRODUCTION_STEP_REDONE',
    PRODUCTION_ABORTED: 'PRODUCTION_ABORTED',
    PRODUCTION_SPOILED: 'PRODUCTION_SPOILED',
    PRESCRIPTION_REMADE: 'PRESCRIPTION_REMADE',
    PRODUCTION_STARTED: 'PRODUCTION_STARTED',
    SCALE_WEIGHT_CAPTURED: 'SCALE_WEIGHT_CAPTURED',
    LABEL_PRINTED: 'LABEL_PRINTED',
    LABEL_REPRINTED: 'LABEL_REPRINTED',
    // STOCK
    BATCH_CREATED: 'BATCH_CREATED',
    BATCH_UPDATED: 'BATCH_UPDATED',
    BATCH_DELETED: 'BATCH_DELETED',
    BATCH_EXPIRY_ACKNOWLEDGED: 'BATCH_EXPIRY_ACKNOWLEDGED',
    BATCH_RECEIVED_FROM_INTERFACE: 'BATCH_RECEIVED_FROM_INTERFACE',
    STOCK_DISCARDED: 'STOCK_DISCARDED',
    REST_VIAL_CREATED: 'REST_VIAL_CREATED',
    REST_VIAL_MOVED: 'REST_VIAL_MOVED',
    REST_VIAL_IN_USE: 'REST_VIAL_IN_USE',
    REST_VIAL_USED: 'REST_VIAL_USED',
    REST_VIAL_DISCARDED: 'REST_VIAL_DISCARDED',
    REST_VIAL_EXPIRED: 'REST_VIAL_EXPIRED',
    RETURN_CREATED: 'RETURN_CREATED',
    RETURN_MOVED: 'RETURN_MOVED',
    RETURN_IN_USE: 'RETURN_IN_USE',
    RETURN_USED: 'RETURN_USED',
    RETURN_DISCARDED: 'RETURN_DISCARDED',
    RETURN_EXPIRED: 'RETURN_EXPIRED',
    // SMART COMPOUNDER EVENTS
    COMPOUND_ORDER_GENERATED: 'COMPOUND_ORDER_GENERATED',
    COMPOUND_ORDER_SENT: 'COMPOUND_ORDER_SENT',
    COMPOUND_ORDER_FAILED: 'COMPOUND_ORDER_FAILED',
    COMPOUND_RESULT_RECEIVED: 'COMPOUND_RESULT_RECEIVED',
    COMPOUND_RESULT_FAILED: 'COMPOUND_RESULT_FAILED',
    COMPOUND_MAPPING_ADDED: 'COMPOUND_MAPPING_ADDED',
    COMPOUND_MAPPING_UPDATED: 'COMPOUND_MAPPING_UPDATED',
    COMPOUND_MAPPING_REMOVED: 'COMPOUND_MAPPING_REMOVED',
    // REPORTS VIEWS
    REPORT_VIEW_CREATED: 'REPORT_VIEW_CREATED',
    REPORT_VIEW_UPDATED: 'REPORT_VIEW_UPDATED',
    REPORT_VIEW_DELETED: 'REPORT_VIEW_DELETED',
    REPORT_VIEW_REORDERED: 'REPORT_VIEW_REORDERED',
};
//# sourceMappingURL=event_logs.js.map